const state = {
    settingscounters:[],
    settingstemplates:[],
};

const getters = {
    getSettingsCounters: state => state.settingscounters,
    getSettingsTemplates: state => state.settingstemplates,
};

const actions = {
    setSettingsCounters: (store, payload) => store.commit("SETTINGSCOUNTERS_SET",payload),
    setSettingsTemplates: (store, payload) => store.commit("SETTINGSTEMPLATES_SET",payload),
};

const mutations = {
    SETTINGSCOUNTERS_SET: (state, payload) => state.settingscounters = payload,
    SETTINGSTEMPLATES_SET: (state, payload) => state.settingstemplates = payload,
};

export default {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
